import { makeStyles } from "tss-react/mui";

const useInfiniteScrollListStyles = makeStyles()((theme) => ({
  mainContainer: {
    flexGrow: 2,
    backgroundColor: theme.palette.surface.light,
    height: "100%",
  },
  itemRows: {
    backgroundColor: theme.palette.surface.darker,
    padding: "8px 8px 0 8px",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  scrollableDiv: {
    height: 50,
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    flexGrow: 2,

    "& .zebra-rows:nth-of-type(odd)": {
      backgroundColor: theme.palette.surface.bgNuanced2,
    },

    "& .zebra-rows:nth-of-type(even)": {
      backgroundColor: theme.palette.surface.light,
    },

    "& .search-rows:last-child": {
      borderBottom: `1px solid ${theme.palette.strokes.defaultGrey}`,
    },
  },
  noRowsContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  noRows: {
    textAlign: "center",
    fontWeight: 500,
    fontSize: "1.125rem",
    margin: "0 0 18px 0",
    color: theme.palette.text.primary,
  },
  search: {
    padding: "8px 8px 8px 16px",
    display: "flex",
    alignItems: "center",
  },
}));

export default useInfiniteScrollListStyles;
